import { render, staticRenderFns } from "./RoleUser.vue?vue&type=template&id=4a6d7cec&scoped=true&"
import script from "./RoleUser.vue?vue&type=script&lang=js&"
export * from "./RoleUser.vue?vue&type=script&lang=js&"
import style0 from "./RoleUser.vue?vue&type=style&index=0&id=4a6d7cec&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a6d7cec",
  null
  
)

export default component.exports